import { render, staticRenderFns } from "./ExhibitChangeOrder.vue?vue&type=template&id=6467433a&"
import script from "./ExhibitChangeOrder.vue?vue&type=script&lang=js&"
export * from "./ExhibitChangeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports